import { render, staticRenderFns } from "./CouponRow.vue?vue&type=template&id=be10b9ae&scoped=true"
import script from "./CouponRow.vue?vue&type=script&lang=ts"
export * from "./CouponRow.vue?vue&type=script&lang=ts"
import style0 from "./CouponRow.vue?vue&type=style&index=0&id=be10b9ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be10b9ae",
  null
  
)

export default component.exports